export default function calibrator() {
    var softFocus = {
        "image": "w_gr.ppm",
        "xml": "w_gr.xml",
        "output_path": "../../output/examples/",
        "output_template": "w_gr",
        "output_extention": "ppm",
        "foundation": {
            "alpha": false,
            "product": ["soft_focus_video"],
            "color": [["#471F82"]],
            "level": 1,
            "feather": [[1]],
            "shape": 0,
            "coverage": "mid"
        }
    };
    var softFocusOnly = {
        "foundation": {
            "alpha": false,
            "product": ["soft_focus_video"],
            "color": [["#471F82"]],
            "level": 1,
            "feather": [[1]],
            "shape": 0,
            "coverage": "mid"
        }
    };
    var baseLook = {
        "image": "w_gr.ppm",
        "xml": "w_gr.xml",
        "output_path": "../../output/examples/",
        "output_template": "w_gr",
        "output_extention": "ppm"
    };
    var softFocusString = JSON.stringify(softFocus);

    var shape = new Map([['highlighter', [[[1]]]], ['eyeshadow', [[[25]]]], ['blush', [[[2]]]], ['bronzer', [[[2]]]], ['eyeliner', [[[27]]]], ['concealer', [[[1]]]]]);

    function turnSKUsIntoLookV2(skus) {
        var look = {};
        for (var w = 0; w < skus.length; w++) {
            look[skus[w].region] = {
                "alpha": false,
                "product": [skus[w].finish],
                "color": [[skus[w].hex]],
                "level": skus[w].region == 'eyeshadow' || skus[w].region == 'highlighter' ? 0 : 1,
                "feather": skus[w].region == 'highlighter' ? [[.5]] : [[1]],
                "shape": shape.has(skus[w].region) ? shape.get(skus[w].region) : null,
                "coverage": skus[w].coverage.replace("medium", "mid").replace("high", "hi").replace("low", "lo")
            };
        }

        Object.assign(look, baseLook);
        var withSoftFocus = JSON.parse(JSON.stringify(look));
        if (!skus.find(function (s) {
            return s.region == 'foundation';
        })) {
            Object.assign(withSoftFocus, softFocusOnly);
        }

        return {
            look: JSON.stringify(look),
            withSoftFocus: JSON.stringify(withSoftFocus)
        };
    }

    function cache(key, fn, stringify) {
        var response = window.sessionStorage.getItem(key);
        if (response) {
            return new Promise(function (resolve, reject) {
                return resolve(stringify ? JSON.parse(response) : response);
            });
        }

        return fn().then(function (r) {
            window.sessionStorage.setItem(key, stringify ? JSON.stringify(r) : r);
            return r;
        });
    }

    return {
        softFocus: softFocusString,
        getLook: function getLook(skus) {
            return new Promise(function (resolve, reject) {
                return resolve(turnSKUsIntoLookV2(skus));
            });
            // if(skus.length > 0){
            //     return cache(`${skus.map(q => Object.values(q).join()).join()}-${new Date().toISOString().split('T')[0]}`, function(){
            //         return new Promise((resolve, reject) => resolve(turnSKUsIntoLookV2(skus)));
            //     },
            //     true);
            // } else {
            //     return new Promise((resolve, reject) => resolve({}));
            // }
        }
    };
}